/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 30th 2022, 3:34:47 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { DocumentTemplatesListView } from "service-builder/components/documents";

export const DocumentTemplatesListPage = () => (
  <div className="os-service-builder-card">
    <DocumentTemplatesListView />
  </div>
);
